import { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { ChildrenDef } from './propTypeDefs';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.object.isRequired,
  children: ChildrenDef,
};

export default withRouter(ScrollToTop);
